import { AlertCircle } from "lucide-react";
import { Link } from "react-router-dom";

export function HelpHomePage() {
  return (
    <div>
      <div className="max-w-5xl min-h-screen mx-auto px-5">
        <div className="my-10">
          <h2 className="text-3xl font-bold">Help Home</h2>
        </div>
        <div className="my-10 grid grid-cols-1 md:grid-cols-2">
          <div className="flex flex-col">
            <h3 className="font-bold text-xl"> General</h3>
            <div className="my-2 flex flex-col gap-3">
              <Link className="underline" to={"/help/login"}>
                Login
              </Link>

              <Link className="underline" to={"/help/register"}>
                Registration
              </Link>
              <Link className="underline" to={"/help/delete-account"}>
                Delete Account
              </Link>
            </div>
          </div>
          <div className="flex flex-col">
            <h3 className="font-bold text-xl"> Expenses</h3>
            <div className="my-2 flex flex-col gap-3">
              <Link className="underline" to={"/help/import-expenses"}>
                Import Expenses
              </Link>
            </div>
          </div>
        </div>

        <div className="my-4 px-4 py-4 border border-amber-400 bg-amber-100">
          <p className="text-amber-600 flex gap-3 text-sm items-center">
            <AlertCircle className="text-amber-500 w-[20px]" />
            More information coming soon.
          </p>
        </div>

        <div className="my-4 px-4 py-4 border border-gray-600 bg-gray-100">
          <p>
            For more questions, please email{" "}
            <strong>help@expensehut.com</strong>
          </p>
        </div>
      </div>
    </div>
  );
}
